import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { SiteUrl } from '@portal-core/sites/models/site-url.model';

@CollectionStateSelectors({
  stateType: SiteUrlsState
})
@State<SiteUrlsState>({
  name: SiteUrlsState.source
})
@Service({ autoProvided: false })
export class SiteUrlsState extends CollectionStateBase {
  static override source: string = 'SiteUrls';
  getSource(): string {
    return SiteUrlsState.source;
  }
}

@Service()
export class SiteUrlsDataService extends CollectionDataServiceBase<SiteUrl> {
  protected readonly stateType = SiteUrlsState;
}
